var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723857 3.5 1L4.5 1ZM3.64644 5.35355C3.8417 5.54882 4.15829 5.54882 4.35355 5.35355L7.53553 2.17158C7.7308 1.97631 7.7308 1.65973 7.53553 1.46447C7.34027 1.26921 7.02369 1.26921 6.82843 1.46447L4 4.29289L1.17157 1.46446C0.97631 1.2692 0.659728 1.2692 0.464466 1.46446C0.269203 1.65972 0.269203 1.97631 0.464465 2.17157L3.64644 5.35355ZM3.5 1L3.5 5L4.5 5L4.5 1L3.5 1Z",
    fill: "#92001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelArrow);
export default __webpack_public_path__ + "static/media/model-arrow.da0f69d04887e2c43e5e261c46cc3e66.svg";
export { ForwardRef as ReactComponent };